import Columns from "../../../library/components/layout/Columns";
import Rows from "../../../library/components/layout/Rows";
import PdfPreviewOverlayBox from "../PdfPreviewOverlayBox";
import { PDF_CANVAS_WIDE_PREVIEW_BOX_WIDTH } from "./pdfCanvasConstants";

interface IPdfPagePreviewStripProps {
    variant: "wide" | "stacked",
    imageUrlList: { uri: string }[],
    overlayDataUrls: string[],
    onScrollToPage: (pageIndex: number) => void,
}

const PdfPagePreviewStrip = (props: IPdfPagePreviewStripProps) => {
    const previewItems = props.imageUrlList.map((image, index) =>
        <Rows
            key={`preview_${index + 1}`}
            gap={3}
            title={`Sayfa ${index + 1}'e git`}
            onClick={() => props.onScrollToPage(index)}
            style={{ alignItems: "center", cursor: "pointer", flexShrink: 0 }}>
            <span style={{ fontSize: "0.78rem", fontWeight: 600 }}>Sayfa {index + 1}</span>
            <PdfPreviewOverlayBox
                baseImageUri={image.uri}
                overlayImageUri={props.overlayDataUrls[index]}
                width={props.variant === "wide" ? PDF_CANVAS_WIDE_PREVIEW_BOX_WIDTH : undefined}
            />
        </Rows>
    );

    if (props.variant === "wide") {
        return <Columns wrap dontGrowForChild gap={8} width="100%" style={{ minHeight: 0, overflow: "auto" }}>
            {previewItems}
        </Columns>;
    }

    return <Columns mb={8} gap={10}>
        <Columns dontGrowForChild gap={8} width="100%" style={{ overflowX: "auto", alignItems: "flex-start" }}>
            {previewItems}
        </Columns>
    </Columns>;
};

export default PdfPagePreviewStrip;
